import { posthog } from 'posthog-js';
import { POSTHOG_API_HOST, POSTHOG_API_KEY } from './constants';

/**
 * Initializes PostHog analytics with the specified configuration
 * @returns void
 */
export const initializePostHog = (): void => {
  try {
    posthog.init(POSTHOG_API_KEY, {
      api_host: POSTHOG_API_HOST,
      persistence: 'localStorage',
      autocapture: false,
      loaded: (posthog) => {
        // if (
        //   posthog &&
        //   posthog.persistence &&
        //   typeof (posthog.persistence as any).isDisabled !== 'function'
        // ) {
        //   (posthog.persistence as any).isDisabled = () => false;
        // }

        if (process.env.NODE_ENV === 'development') {
          console.log('PostHog initialized successfully');
        }
      },
    });
  } catch (error) {
    console.error('Failed to initialize PostHog:', error);
  }
};

export const identifyPostHogUser = ({ userId }: { userId: string }) => {
  try {
    if (posthog.__loaded) {
      posthog.identify(userId);
    }
  } catch (err) {
    console.log(err);
  }
};
